import { DateTime } from 'luxon'

export default class ScheduleService {
  static FREQUENCY_OPTIONS = [
    {label: 'Semanal', value: 'weekly', interval: { weeks: 1 }},
    {label: 'Quinzenal', value: 'biweekly', interval: { weeks: 2 }},
    {label: 'Mensal', value: 'monthly', interval: { months: 1 }}
  ]
  
  static getFormattedDuration (duration) {
    const hours = Math.floor (duration / 60)
    const minutes = duration % 60
    return `${hours ? (hours + 'h') : ''}${minutes ? (minutes + 'm') : ''}`
  }

  static getRecurrenceDates (recurrence, date) {
    const dates = []
    let current = DateTime.fromISO (date)
    let count = 0

    const interval = recurrence.frequency?.interval || { weeks: 1 }
    current = current.plus (interval)

    if (recurrence.type?.value === 'scheduleCount') {
      while (count < recurrence.scheduleCount - 1) {
        if (!recurrence.skipDates?.includes (current.toISODate ())) {
          dates.push (current.toISODate ())
          count++
        }
        current = current.plus (interval)
      }
    } else if (recurrence.type?.value === 'endDate') {
      const endDate = DateTime.fromISO (recurrence.endDate)

      while (current <= endDate) {
        if (!recurrence.skipDates?.includes (current.toISODate ())) {
          dates.push (current.toISODate ())
        }
        current = current.plus (interval)
      }
    }

    return dates
  }
}
